import { CustomerData } from 'app/types/backend-api'
import { createReduxSlice } from '../../ReduxSlice'
import { fetchCustomerDataAsync } from './customers-async'
import { State } from 'app/types/redux-types'
import { PayloadAction } from '@reduxjs/toolkit'

export type CustomerDataError = { message: string; code?: string | number; stack?: string }

const initialState: State<CustomerData> = {
  data: {} as CustomerData,
  status: 'idle',
  error: null
}

const customerSlice = createReduxSlice({
  name: 'customerSlice',
  initialState,
  asyncThunks: {
    customerData: fetchCustomerDataAsync
  },
  reducers: {
    updateCustomerState: (state, action: PayloadAction<CustomerData>) => {
      const { customers, offers } = action.payload
      if (state.data) {
        Object.assign(state.data, {
          offers,
          customers
        })
      }
    },
    // richer error reducer (message/code/stack); named distinctly to avoid clashing with the factory's string-only setError
    setCustomerDataError: (state, action: PayloadAction<CustomerDataError>) => {
      state.error = action.payload.message
      state.errorDetails = { code: action.payload.code, stack: action.payload.stack }
      state.status = 'failed'
    }
  }
})
export const {
  customerData,
  setData: updateCustomerState,
  setCustomerDataError,
  reset: resetCustomerData
} = customerSlice.actions

export default customerSlice.reducer
